import { useState, useEffect, useReducer } from "react";
import { useNavigate, useLocation } from "react-router-dom"
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import MutipleChoiceQuestion from "../MultipleChoiceQuestion";
import NumericQuestion from "../NumericQuestion";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import styles from "./profile.module.css";

const reducer = (state, action) => {
    switch (action.type) {
        case ACTION.NEW_QUESTIONS:
            let dataLoaded = true;
            return { ...state, questions: [...action.payload], dataLoaded: dataLoaded };
        case ACTION.NEW_RESPONSES:
            const surveyQuestionId = action.payload.surveyQuestionId;
            const newQuestions = structuredClone(state.questions);
            for (let question of newQuestions) {
                if (question.surveyQuestionId === surveyQuestionId) {
                    question.responses = [...action.payload.responses];
                }
            }
            return { ...state, questions: newQuestions };
        default:
            console.log(`unhandled action.type: ${action.type}`)
    }
}

const ACTION = {
    NEW_QUESTIONS: "newQuestions",
    NEW_RESPONSES: "newResponses",
}

const Profile = () => {

    const axiosPrivate = useAxiosPrivate();

    const navigate = useNavigate();
    const location = useLocation();

    const [alertStatus, setAlertStatus] = useState({
        open: false
    });


    const [state, dispatch] = useReducer(reducer, {
        questions: [],
        dataLoaded: false
    });

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertStatus((prev) => {
            return { ...prev, open: false }
        });
    };

    useEffect(() => {

        let isMounted = true;
        const controller = new AbortController();

        const getUser = async () => {
            try {
                const response = await axiosPrivate.get('/profile', {
                    signal: controller.signal
                });
                if (isMounted) {
                    dispatch({
                        type: ACTION.NEW_QUESTIONS, payload: [...response.data.questions]
                    });
                }
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                    if (err.response?.status === 403) {
                        navigate('/login', { state: { from: location }, replace: true });
                    }
                }
            }
        }

        getUser();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const saveResponse = async (params) => {

        const json = { ...params };

        try {
            const response = await axiosPrivate.post(`/surveyQuestions/${params.surveyQuestionId}`,
                JSON.stringify(json),
                {
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            dispatch({
                type: ACTION.NEW_RESPONSES, payload: { ...response.data }
            });
            setAlertStatus({
                open: true,
                severity: "success",
                message: "Successfully updated profile"
            });
        } catch (err) {
            console.log(err);
            if (err.response?.status === 403) {
                navigate('/login');
            }
            let message;
            if (!err?.response) {
                message = 'No Server Response';
            } else if (err.response?.status === 404) {
                message = 'Could not update profile';
            } else {
                message = 'Unknown error';
            }
            setAlertStatus({
                open: true,
                severity: "error",
                message: message
            });
        }
    }

    return (
        <section className="wide">
            <div>

                <h1 className={styles.title}>Profile</h1>
                {
                    state.questions.map((question, i) => {
                        switch (question.surveyQuestionType) {
                            case "multiple choice":
                                return (
                                    <div key={i} className="dashboard-question-container">
                                        <ol className="title">
                                            <li value={i + 1}>{question.text}</li>
                                        </ol>
                                        <MutipleChoiceQuestion question={question} answerChoices={question.answerChoices} responses={question.responses} saveResponse={saveResponse} compact={true} />
                                    </div>
                                )
                            case "numeric":
                                return (
                                    <div key={i} className="dashboard-question-container">
                                        <ol className="title">
                                            <li value={i + 1}>{question.text}</li>
                                        </ol>
                                        <NumericQuestion question={question} answerChoices={question.answerChoices} responses={question.responses} saveResponse={saveResponse} compact={true} />
                                    </div>
                                )
                            default:
                                return null
                        }

                    })
                }
            </div>
            <Snackbar open={alertStatus.open} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} variant="filled" severity={alertStatus.severity} sx={{ width: '100%' }}>{alertStatus.message}</Alert>
            </Snackbar>
        </section>
    )
}

export default Profile
